import { Avatar } from "@/components/tuw/Avatar"
import { initialsFor } from "@/components/tuw/hire/FreelancerAvatar"
import StarRating from "@/components/tuw/hire/StarRating"

// A single customer review in the profile Reviews stream. Customer reviews are
// the only source shown (and the only one that feeds the headline ★ average) —
// peer/collaborator reviews are intentionally not surfaced.
export default function ReviewCard({ review }) {
  return (
    <div className="border-b border-border py-[18px] first:pt-0 last:border-none last:pb-0">
      <div className="mb-[9px] flex items-center gap-[11px]">
        <Avatar initials={initialsFor(review.by)} name={review.by} size={38} />
        <div>
          <div className="font-display text-[13.5px] font-bold">{review.by}</div>
          <div className="flex flex-wrap items-center gap-[6px] text-[11.5px] text-ink-3">
            <span className="rounded-full bg-secondary px-[7px] py-px text-[10px] font-bold tracking-[0.03em] text-muted-foreground uppercase">
              Customer
            </span>
            <span>· {review.date}</span>
          </div>
        </div>
        <div className="flex-1" />
        {review.rating != null && <StarRating rating={review.rating} showCount={false} />}
      </div>
      {review.text && (
        <div className="text-[13.5px] leading-[1.6] text-muted-foreground">{review.text}</div>
      )}
    </div>
  )
}
